import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { loadBlogList } from "@/lib/seo/blogList";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/es/blog/")({
  loader: () => loadBlogList("es"),
  head: () =>
    buildRouteHead("/es/blog", {
      title: "Blog de Life Sciences — Insights y Novedades | QbD Group",
      description:
        "Mantente al día con los últimos insights regulatorios, novedades del sector y perspectivas de los expertos de QbD Group.",
    }),
  component: Blog,
});

